import { AbTestTypeCategoryToDropdownOptions } from '../../../models/AbTestCreationType';

const useAbTestTypeOptions = () => AbTestTypeCategoryToDropdownOptions;

export default useAbTestTypeOptions;
